import { Deserializer } from 'jsonapi-serializer';
import normalize from 'json-api-normalizer';
import { DEFAULT_SELECT_CATEGORY_OPTION } from 'constants/data';
import { parseFilters, parseCountrySectors } from 'utils/data';
import { getLatestYear } from 'utils/general';
import * as queryString from 'query-string';

// Actions
const GET_LIST = 'countries/GET_LIST';
const SET_SECTOR = 'countries/SET_SECTOR';
const GET_CATEGORIES = 'countries/GET_CATEGORIES';
const GET_SUBCATEGORIES = 'countries/GET_SUBCATEGORIES';
const GET_INDICATORS = 'countries/GET_INDICATORS';
const GET_BY_COUNTRY = 'countries/GET_BY_COUNTRY';
const SET_FILTERS = 'countries/SET_FILTERS';
const GET_COMPOSITES = 'data/GET_COMPOSITES';
const GET_REGIONS = 'data/GET_REGIONS';
const SORT_LIST = 'countries/SORT_LIST';
const SET_COUNTRY_SECTORS = 'data/SET_COUNTRY_SECTORS';
const SET_COUNTRY_SECTORS_LOADING = 'data/SET_COUNTRY_SECTORS_LOADING';
const GET_ACTIVE_YEARS = 'data/GET_ACTIVE_YEARS';
const GET_ACTIVE_YEARS_LOADING = 'data/GET_ACTIVE_YEARS_LOADING';

// Reducer
const initialState = {
  filters: {
    sector: 'both',
    displayBy: 'issue',
    category: '',
    subcategory: '',
    indicator: '',
    region: 'global',
    countryCategory: '',
    years: [2017]
  },
  options: {
    regions: [],
    composites: [],
    categories: [],
    subcategories: [],
    indicators: []
  },
  sort: {
    type: 'rank',
    direction: 'asc'
  },
  list: [],
  data: {},
  activeYears: [],
  activeYearsLoading: false,
  countrySectors: [],
  countrySectorsLoading: false
};
const cache = {};
// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FILTERS:
      return Object.assign({}, state, { filters: action.payload });
    case GET_LIST:
      return Object.assign({}, state, { list: action.payload });
    case SET_SECTOR: {
      const newOptions = Object.assign({}, state.options, { sector: action.payload });
      return Object.assign({}, state, { options: newOptions });
    }
    case GET_CATEGORIES: {
      const newOptions = Object.assign({}, state.options, { categories: action.payload });
      return Object.assign({}, state, { options: newOptions });
    }
    case GET_ACTIVE_YEARS_LOADING: {
      return Object.assign({}, state, { activeYearsLoading: action.payload });
    }
    case GET_ACTIVE_YEARS: {
      return Object.assign({}, state, { activeYears: action.payload, activeYearsLoading: false });
    }
    case GET_SUBCATEGORIES: {
      const newOptions = Object.assign({}, state.options, { subcategories: action.payload });
      return Object.assign({}, state, { options: newOptions });
    }
    case GET_INDICATORS: {
      const newOptions = Object.assign({}, state.options, { indicators: action.payload });
      return Object.assign({}, state, { options: newOptions });
    }
    case GET_REGIONS: {
      const newOptions = Object.assign({}, state.options, { regions: action.payload });
      return Object.assign({}, state, { options: newOptions });
    }
    case GET_BY_COUNTRY: {
      const data = Object.assign({}, state.data, {});
      data[action.payload.iso] = action.payload.data;
      return Object.assign({}, state, { data });
    }
    case GET_COMPOSITES: {
      const options = Object.assign({}, state.options, { composites: [action.payload] });
      return Object.assign({}, state, { options });
    }
    case SET_COUNTRY_SECTORS_LOADING: {
      return Object.assign({}, state, { countrySectorsLoading: action.payload });
    }
    case SET_COUNTRY_SECTORS: {
      return Object.assign({}, state, { countrySectors: action.payload, countrySectorsLoading: false });
    }
    case SORT_LIST:
      return Object.assign({}, state, { sort: {
        type: action.payload.type,
        direction: action.payload.direction
      } });
    default:
      return state;
  }
}

export function setDataFilters(filters) {
  return {
    type: SET_FILTERS,
    payload: filters
  };
}

export function getDataList() {
  const url = `${config.apiHost}/data`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: GET_LIST,
          payload: data
        });
      });
  };
}

export function setSector(sector) {
  return {
    type: SET_SECTOR,
    payload: sector
  };
}

export function setSortBy(type, direction) {
  return {
    type: SORT_LIST,
    payload: { type, direction }
  };
}

export function getCategories() {
  const url = `${config.apiHost}/categories`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(d => {
        new Deserializer().deserialize(d, (err, dataParsed) => {
          dispatch({
            type: GET_CATEGORIES,
            payload: parseFilters(dataParsed)
          });
        });
      });
  };
}

export function getComposites() {
  const url = `${config.apiHost}/composites`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(d => {
        new Deserializer().deserialize(d, (err, dataParsed) => {
          const { average, max, min } = dataParsed.length ? dataParsed[0] : {};
          dispatch({
            type: GET_COMPOSITES,
            payload: { ...DEFAULT_SELECT_CATEGORY_OPTION, average, max, min }
          });
        });
      });
  };
}

export function getSubcategories(categoryId) {
  const url = `${config.apiHost}/categories/${categoryId}?include=subcategories`;
  return dispatch => {
    if (categoryId !== '0') {
      fetch(url)
      .then(response => response.json())
      .then(data => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          dispatch({
            type: GET_SUBCATEGORIES,
            payload: parseFilters(dataParsed.subcategories)
          });
        });
      });
    } else {
      dispatch({
        type: GET_SUBCATEGORIES,
        payload: []
      });
    }
  };
}

export function getIndicators(subcategoryId) {
  const url = `${config.apiHost}/subcategories/${subcategoryId}?include=indicators`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          const indicators = dataParsed.indicators.map((dp) => {
            const { average, id, max, min, name } = dp;
            return ({ average, id, max, min, name });
          });

          dispatch({
            type: GET_INDICATORS,
            payload: indicators
          });
        });
      });
  };
}

export function getCountrySectors(filters = {}) {
  let endPoint = '';
  let params = '';
  const years = filters.years;

  switch (true) {
    case filters.indicator !== '':
      endPoint = `/indicators/${filters.indicator}`;
      params = queryString.stringify({
        include: 'country-sector-indicators.country-sector.country.groups,country-sector-indicators.country-sector.sector'
      });

      break;

    case filters.subcategory !== '':
      endPoint = `/subcategories/${filters.subcategory}`;
      params = queryString.stringify({
        include: 'country-sector-subcategories.country-sector.country.groups,country-sector-subcategories.country-sector.sector'
      });

      break;

    case filters.category !== '':
      endPoint = `/categories/${filters.category}`;
      params = queryString.stringify({
        include: 'country-sector-categories.country-sector.country.groups,country-sector-categories.country-sector.sector'
      });
      break;

    default:
  }

  const url = `${config.apiHost}${endPoint}?${params}${years ? `&years=${years}` : ''}`;
  const latestYear = getLatestYear(years);
  return dispatch => {
    if (!endPoint.length) {
      dispatch({
        type: SET_COUNTRY_SECTORS,
        payload: []
      });
    } else {
      dispatch({
        type: SET_COUNTRY_SECTORS_LOADING,
        payload: true
      });
      fetch(url)
      .then(response => response.json())
      .then(data => {
        const normalizedData = normalize(data);
        const parsedData = parseCountrySectors(normalizedData);
        // sorting as per latest year
        if (latestYear) { dispatch(setSortBy(`score${latestYear}`, 'desc')); }
        dispatch({
          type: SET_COUNTRY_SECTORS,
          payload: parsedData
        });
      })
      .catch(() => {
        dispatch({
          type: SET_COUNTRY_SECTORS_LOADING,
          payload: false
        });
      });
    }
  };
}

export function getRegions() {
  const url = `${config.apiHost}/groups`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        const regions = normalize(data).groups;

        dispatch({
          type: GET_REGIONS,
          payload: Object.values(regions)
        });
      });
  };
}

export function getActiveYears() {
  const url = `${config.apiHost}/active-years`;
  return dispatch => {
    if (cache[url]) {
      dispatch({
        type: GET_ACTIVE_YEARS,
        payload: cache[url].active_years.map(el => el.replace('score_', ''))
      });
      return;
    }
    dispatch({
      type: GET_ACTIVE_YEARS_LOADING,
      payload: true
    });
    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data && data.active_years) {
          cache[url] = data;
          dispatch({
            type: GET_ACTIVE_YEARS,
            payload: data.active_years.map(el => el.replace('score_', ''))
          });
        }
      })
      .catch(() => {
        dispatch({
          type: GET_ACTIVE_YEARS_LOADING,
          payload: false
        });
      });
  };
}

export function getDataByCountry(iso) {
  const url = `${config.apiHost}/data/${iso}`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: GET_BY_COUNTRY,
          payload: { iso, data }
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/data.js